import BackendAPI from '../../../core/static/js/helpers/API.js'
import { setCookie, getCookie } from '../../../core/static/js/helpers/utils.js'

export default class ProductDetails extends HTMLElement {
  constructor() {
    super();
    this.API = new BackendAPI();
    this.API.setBaseUrl(host + '/product');
    this._group = {};
    this.seller = this.seller;
    this.metrologyInfo = {"unit":"", "rangeLabel":"", "lengthLabel":"", "category":"", "style":"", "fabric":"", "composition":"", "fit":"", "care":"", "net_weight":"", "net_qty":"", "specsLabel":""};

    this._products = {}
    this._swatches = {}
    this._images = {}
    this._shippingInfo = ''
    this.finalSale = false;
    this._sizeGuideUrl = null;
    this._styles = [];
    this._currentSize = null;
    this._currentStyle = shop_url.style;
  }

  get group() {
    return this._group;
  }
  set group(val) {
    this._group = val;
    this.setDescription();
    this.setGroupClass();
    this.setdisclaimerBlock();
  }

  get sizes() {
    return this._sizes;
  }
  set sizes(val) {
    this._sizes = val;
  }
  get styles() {
    return this._styles;
  }
  set styles(val) {
    this._styles = val;
  }

  get offerText() {
    return this._offerText;
  }
  set offerText(val) {
    this._offerText = val;
  }

  get products() {
    return this._products;
  }
  set products(val) {
    this._products = val;
    this.setProductAttributes();
    this.setShippingAndReturns();
    this.shippingDateOnSizeChange();
    this.handleSizeChangeOnSizeGuide();
    this.handleUnitChangeOnSizeGuide();
  }

  get sizeGuideInfo() {
    return this._sizeGuideInfo;
  }
  set sizeGuideInfo(val) {
    this._sizeGuideInfo = val;
    this.setMetrologyUnits(val);
  }
  get swatches() {
    return this._swatches;
  }
  set swatches(val) {
    this._swatches = val;
  }
  get images() {
    return this._images;
  }
  set images(val) {
    this._images = val;
  }
  get shippingInfo() {
    return this._shippingInfo;
  }
  set shippingInfo(val) {
    this._shippingInfo = val;
  }
  get currentSize() {
    return this._currentSize;
  }
  set currentSize(val) {
    this._currentSize = val;
    this.saveSizeData(this.currentSize);
  }
  get currentStyle() {
    return this._currentStyle;
  }
  set currentStyle(val) {
    this._currentStyle = val;
    this.setdisclaimerBlock();
  }
  setdisclaimerBlock(){
      let disclaimerBlock = (this._group && this._group.footnote) ? `<p class="footnote">${this._group.footnote}</p>`: "";
      this.querySelector('.product-info-block.extra').innerHTML = disclaimerBlock;
  }
  
  restrictSale(){
      let buyingOptionsBlock = document.querySelector('#buyingOptions');
      let saleRestrictedBlock = document.querySelector('#saleRestricted');
      saleRestrictedBlock.style.display = "block";
      buyingOptionsBlock.style.display = "none";
  }
  
  allowSale(){
      let buyingOptionsBlock = document.querySelector('#buyingOptions');
      let saleRestrictedBlock = document.querySelector('#saleRestricted');
      saleRestrictedBlock.style.display = "none";
      buyingOptionsBlock.style.display = "block";
  }

  setDescription() {
    if (this._group && this._group.description) {
      this.querySelector('.feature').innerHTML = this._group.description;
    }
  }
  
  saveSizeData(size){
    let productData = getCookie('product_data');
    let type = this.getAttribute('type');
    let style = this.querySelector('product-nav').style;
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              product[type][style] = size;
              setCookie('product_data', JSON.stringify(productDataList), 10*365);
            } 
        }
      } 
    }
  }
  getSizeFromCookies(){
    let productData = getCookie('product_data');
    let type = this.getAttribute('type');
    let style = this.querySelector('product-nav').style;
    let size = null;
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              size = product[type][style]
            } 
        }
      } 
    }
    return size;
  }
  
  setGroupClass() {
    if (this._group) {
      document.querySelector('main.product').setAttribute('data-group',this.group.id);
    }
  }

  setSizingDisclaimer() {
    let sizeDisclamerBlock = this.querySelector('.sizing-disclaimer');
    if(sizeDisclamerBlock){
      if(this.seller === 'IN'){
        sizeDisclamerBlock.style.display = "none";
      }
      var categoriesToCheck = ['pyjamas', 'shorts', 'hammo-tracks', 'hammo-shorts', 'flat-pants', 'ribbed-shorts', 'hammo-365-zipup', 'hammo-365-tracks', 'hammo-365-shorts', 'hammo-pants', 'hammo-lounge-pants', 'trunks', 'boxers', 'apron', 'pyjamas', 'suvin-pyjamas', 'lintroller'];
      if (categoriesToCheck.includes(this.getAttribute('type'))) {
        sizeDisclamerBlock.style.display = "none";
      }
    }
  }

  setMultipleOffers(forSale) {
    let offerText = this.querySelector('#offerText');
    if (offerText) {
      if (forSale === 'true' || forSale == true) {
        offerText.style.display = 'none';
      } else {
        offerText.style.display = 'flex';
      }
    }
    this.animateOffers();
  }

  setLegalMetrologyInfo() {
    let metrologyBlock = this.querySelector('#metrology-block');
    if (this.getAttribute('type') == 'one-offs') {
      metrologyBlock.style.display = 'none';
      return;
    }
    if (metrologyBlock) {
      var metrologyInfo = this.metrologyInfo;
      var metrologyCategory = metrologyInfo.category;
      var metrologyStyle = metrologyInfo.style;
      var metrologyComposition = metrologyInfo.composition;
      var metrologyCare = metrologyInfo.care;
      var metrologyNetWeight = metrologyInfo.net_weight;
      var metrologyNetQty = metrologyInfo.net_qty;
      var metrologyCategoryElement = metrologyBlock.querySelector('#metrology-category');
      var metrologyStyleElement = metrologyBlock.querySelector('#metrology-style');
      var metrologyCompositionElement = metrologyBlock.querySelector('#metrology-composition');
      var metrologyCareElement = metrologyBlock.querySelector('#metrology-care');
      var metrologyNetWeightElement = metrologyBlock.querySelector('#metrology-net-wt');
      var metrologyNetQtyElement = metrologyBlock.querySelector('#metrology-net-qty');
      if (metrologyCategoryElement) {
        metrologyCategoryElement.textContent = metrologyCategory;
      }
      // if (metrologyStyleElement) {
      //   metrologyStyleElement.textContent = metrologyStyle;
      // }
      if (metrologyCompositionElement) {
        metrologyCompositionElement.textContent = metrologyComposition;
      }
      // if (metrologyCareElement) {
      //   metrologyCareElement.textContent = metrologyCare;
      // }
      if (metrologyNetWeightElement) {
        metrologyNetWeightElement.textContent = metrologyNetWeight;
      }
      if (metrologyNetQtyElement) {
        metrologyNetQtyElement.textContent = metrologyNetQty;
      }
    }
  }



  setShippingAndReturns() {
    let shipping = this.shippingDetails.shipping;
    let delivery = this.shippingDetails.delivery;
    let warehouse = this.shippingDetails.warehouse;
    let returns = '';
    let sizePickerBlock = this.querySelector('div.open-sizepicker');
    let selectedSize = sizePickerBlock.querySelector('a.selected');
    if (selectedSize){
      this.finalSale = selectedSize.getAttribute('data-finalSale');
    }
    if (this.finalSale == 'true') {
      returns = '<span class="alert">No returns</span>';
    }
    else {
      returns = this.shippingDetails.returns + ' <a href="/returns">easy returns</a>';
    }
    this.querySelector('#returnsInfo').innerHTML = returns;
  }
  setAddBtnText(selectedSize, addBtn){
    let originalPriceText = addBtn.querySelector('#originalPrice');
    if (this.products && Object.keys(this.products).length > 0 && selectedSize){
        let product = this.products.find(function(p){
            if (p.sku == selectedSize.getAttribute('data-sku') ){
               return p;
            }
      });
      if (product && product.out_of_stock){
        if(addBtn){
          addBtn.classList.add('disabled');
          addBtn.innerHTML = `
            <p>Sold Out</p>
            <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
        }
        if (originalPriceText){
          originalPriceText.textContent = '';
        }
      }
      else{
        if (addBtn){
          if (!this.setAnonPrice){
            addBtn.innerHTML = `
              <p>Add for ${this.currentPrice}</p>
              <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
          }
          else{
            addBtn.innerHTML = `
              <p>Add to Cart</p>
              <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
          }
        }
        if (originalPriceText){
            originalPriceText.textContent = `Original Price ${this.originalPrice}`;
        }
      }
    }
  }


  setSizeAriaLabels(aTag, unit='inches', rangeLabel, lengthLabel, setExcplicitAriaLabel=false){
    let inchesRange = aTag.getAttribute('data-range-inches');
    let cmsRange = aTag.getAttribute('data-range-cm');
    if (setExcplicitAriaLabel && setExcplicitAriaLabel !== ''){
      aTag.setAttribute('aria-label', setExcplicitAriaLabel);
      return;
    }
    if (unit == 'inches'){
      if (/\d/.test(inchesRange)) {
        inchesRange = inchesRange.replace(/(\d+(\.\d+)?)/g, '$1\'\'');
      }
      aTag.setAttribute('aria-label', `${rangeLabel} ${inchesRange}`);

    }
    else{
      if (/\d/.test(cmsRange)) {
        cmsRange = cmsRange.replace(/(\d+(\.\d+)?)/g, '$1cm');
      }
      aTag.setAttribute('aria-label', `${rangeLabel} ${cmsRange}`);
    }
  }


  connectedCallback() {
    this.shippingDetails = JSON.parse(this.getAttribute("shippingDetails"));
    this.images = JSON.parse(this.getAttribute('images'));
    this.swatches = JSON.parse(this.getAttribute("swatches"));
    this.offerText = this.getAttribute('offerText');
    this.styles = JSON.parse(this.getAttribute('styles'));
    this.seller = this.getAttribute('seller');
    this.clubbedProducts = JSON.parse(this.getAttribute('clubbedProducts'));
    this.typeInfo = JSON.parse(this.getAttribute('typeInfo')) || {};
    this.type = this.getAttribute('type');
    this.setAnonPrice = this.type == 'socks';
    this.renderTemplate();
    this.setDescription();
    this.setGroupClass();
    this.setProductAttributes();
    this.attachEventListeners();
    this.setShippingAndReturns();
    this.setSizingDisclaimer();
  }

  attachEventListeners() {
    this.attachAddButtonClick();
  }

  disconnectedCallback() {
  }

  renderTemplate() {
    const name = this.getAttribute('productTypeName');
    const type = this.getAttribute('type');
    const productDetailsTemplate = document.createElement('template');
    const renderPack = this.getAttribute("renderPack");

    productDetailsTemplate.innerHTML = `
    <section id="details" class="">
        <div class="details-content">
          <product-nav name="${name}" type=${type} swatches='${JSON.stringify(this.swatches)}' images='${JSON.stringify(this.images)}', styles='${JSON.stringify(this.styles)}' renderPack='${renderPack}' clubbedProducts='${JSON.stringify(this.clubbedProducts)}' shop_url="${shop_url}" typeInfo='${JSON.stringify(this.typeInfo)}'></product-nav>
          <div class="container-fluid" id="standardInfo">
            <div class="row">
              <div class="col-md-10 col-md-offset-1 col-xs-12">
                <div class="product-info-block features-overview">
                  <h2 class="serif para feature"></h2>
                  <div class="helper">
                    ${(() => {
                      if(type == 'hair-wrap'){
                        return `<a href="/hair-wrap/guide" class="video-button hair-wrap" target="_blank"><p class="footnote">How to wear</p></a>`
                      }
                      if(['suvin-tee', 'suvin-v', 'suvin-vest', 'suvin-heavy', 'suvin-heavy-polo', 'suvin-hammo-lite'].includes(type)){
                        return `<a href="https://www.instagram.com/reel/C7HCffOoiGE/?igsh=MTB0eXRpN2tyM2Zkdg==" class="video-button " target="_blank"><p class="footnote">The Suvin Story</p></a>`
                      }
                      else{
                        return `<a href="#features"><p class="footnote">Learn More</p></a>`
                      }
                    })()
                    }
                  </div>
                </div>
                <div class="product-info-block extra">
                </div>
                <div class="mto-graphic-wrapper">
                  <div class="mto-graphic-text"></div>
                  <div class="mto-graphic-icon"></div>
                </div>
              </div>
            </div>
          </div>
          ${ '' /* commented PJ color picker for now ${(type == 'pyjamas') ? "<nav class='swatches col-four' id='block-swatches'></nav>": ""} */ }
          <div class="container-fluid" id="buyingOptions">
            <div class="row">
                <div class="col-md-10 col-md-offset-1 col-xs-12">
                  <div class="size-picker">
                    <p class="footnote">
                    <span class="title">Size</span>
                      <span class="sizing-disclaimer">
                        <span class="seperator">&middot;</span>
                        <span class="">Size up for a perfect fit—our sizing runs smaller than standard</span> 
                      </span>
                    </p>
                    <div class="size-list open-sizepicker"></div>
                  </div>
                  <div class="shipping-returns">
                    <p class="footnote">
                      <span id="productStatus">In stock</span>
                      <span class="shipping-middot seperator">&middot;</span>
                      <span id="shippingInfo">Ships today</span> 
                      <span class="return-middot seperator">&middot;</span>
                      <span id="returnsInfo">14-day returns</span>
                    </p>
                  </div>
                  <div class="pricing-offers">
                    <a href="javascript:void(0);" id="addToCart" class="button button-medium rounded">
                      <p class=""></p>
                      <p class="super-subtle">MRP (Inc. of all Taxes)</p>
                    </a>
                    <div class="active-offers">
                      <div class="offer"><p class="footnote" id="originalPrice"></p></div>
                      <div class="offer" id="offerText"><p class="footnote">${this.offerText}</p></div>
                    </div>
                  </div>
                  <div class="alt-action legal-info">
                    <a class="toggle">
                      <p class="footnote title">Product Info</p>
                    </a>
                    <div class="toggle-info hidden">
                      <div id="metrology-block" class="main-info out-of-sight">
                        <div class="col">
                          <p class="footnote"><span class="title">Category</span> <span id="metrology-category">${this.metrologyInfo.category}</span></p>
                          <p class="footnote"><span class="title">Composition</span> <span id="metrology-composition">${this.metrologyInfo.composition}</span></p>
                        </div>
                        <div class="col">
                          <p class="footnote"><span class="title">Net Wt.</span> <span id="metrology-net-wt">${this.metrologyInfo.net_weight}</span></p>
                          <p class="footnote"><span class="title">Net Qty.</span> <span id="metrology-net-qty">${this.metrologyInfo.net_qty}</span></p>
                        </div>
                      </div>
                      <div class="supplier-info out-of-sight">
                        <p class="footnote super-subtle">
                          Country of Origin: India <br>
                          Mfg & Marketed by March Work Pvt Ltd <br>
                          Floor 1, 3rd Street 16 Ashar Nagar, Tiruppur 641063 <br>
                          <a href="mailto@help@marchtee.com">help@marchtee.com</a>
                        </p>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div class="container-fluid" id="saleRestricted">
            <div class="row">
                <div class="col-md-10 col-md-offset-1 col-xs-12">
                  <div class="invite-only-wrapper">
                    <p class="footnote">
                      <span class="title">Made in small batches</span>
                      <span class="shipping-middot seperator">&middot;</span>
                      <span id="">Check back later</span> 
                    </p>
                    <a href="javascript:void(0);" id="subscribeBtn" class="button button-medium rounded button-outline alt-action subscribe-modal-link">Stay Tuned</a>
                  </div>
              </div>
            </div>
        </div>
      </section>`;
    this.appendChild(productDetailsTemplate.content.cloneNode(true));
  }




  updateSizeLabels(unit) {
    const rangeLabel = this.metrologyInfo.rangeLabel;
    const lengthLabel = this.metrologyInfo.lengthLabel;
    const sizePickerBlock = this.querySelector('div.open-sizepicker');
    if (!sizePickerBlock) return;
    const sizeButtons = sizePickerBlock.querySelectorAll('a.size');
    Array.from(sizeButtons).forEach(button => {
      if(button.classList.contains('out-of-stock')){
        this.setSizeAriaLabels(button, unit, rangeLabel, lengthLabel, "Out of Stock");
      }
      else{
        this.setSizeAriaLabels(button, unit, rangeLabel, lengthLabel);
      }
    });
  }


  setMetrologyUnits(val=null) {
    var sizeGuideData;
    if (val) {
      sizeGuideData = val;
      this.metrologyInfo.rangeLabel = sizeGuideData.range_label;
      this.metrologyInfo.lengthLabel = sizeGuideData.length_label;
      this.metrologyInfo.specsLabel = sizeGuideData.specs_label;
      this.metrologyInfo.category = sizeGuideData.category;
      this.metrologyInfo.style = sizeGuideData.style;
      this.metrologyInfo.fabric = sizeGuideData.fabric;
      this.metrologyInfo.composition = sizeGuideData.composition;
      this.metrologyInfo.fit = sizeGuideData.fit;
      this.metrologyInfo.care = sizeGuideData.care;
      this.metrologyInfo.net_weight = sizeGuideData.net_weight;
      this.metrologyInfo.net_qty = sizeGuideData.net_qty;
    }
    else {
      this.metrologyInfo.rangeLabel = "Chest";
      this.metrologyInfo.lengthLabel = "Tee";
    }

    let metrologyData = getCookie('metrologyInfo');
    if (!metrologyData) {
      this.metrologyInfo.unit = 'inches';
      setCookie('metrologyInfo', JSON.stringify(this.metrologyInfo));
    }
    else {
      var decodedMetrologyData = JSON.parse(metrologyData);
      this.metrologyInfo.unit = (decodedMetrologyData.unit === 'inches' || decodedMetrologyData.unit === 'cms') ? decodedMetrologyData.unit : 'inches';
    }
  }
  handleUnitChangeOnSizeGuide() {
    document.addEventListener('MetrologyUnitChanged', (event) => {
      const { unit } = event.detail;
      this.metrologyInfo.unit = (unit === 'inches' || unit === 'cms') ? unit : 'inches';
      setCookie('metrologyInfo', JSON.stringify(this.metrologyInfo));
      this.updateSizeLabels(this.metrologyInfo.unit);
    });
  }

  handleSizeChangeOnSizeGuide() {
    document.addEventListener('sizeSelected', (event) => {
        const { sku, size } = event.detail;
        const sizePickerBlock = this.querySelector('div.open-sizepicker');
        if (!sizePickerBlock) return;

        // Find the matching size button by SKU
        const matchingSizeButton = Array.from(sizePickerBlock.children)
            .find(button => button.getAttribute('data-sku') === sku);
            
        if (matchingSizeButton) {
            // Remove selected class from all buttons
            sizePickerBlock.querySelectorAll('.selected').forEach(btn => {
                btn.classList.remove('selected');
            });
            
            // Add selected class and trigger all necessary updates
            matchingSizeButton.classList.add('selected');
            this.currentSize = matchingSizeButton.textContent;
            this.currentPrice = matchingSizeButton.getAttribute('data-price');
            this.originalPrice = matchingSizeButton.getAttribute('data-original-price');
            this.finalSale = matchingSizeButton.getAttribute('data-finalSale');
            this.weightInGms = matchingSizeButton.getAttribute('data-weight-gms');
            this.classList.remove('attention');
            

            
            // Update stock status
            const stockStatus = matchingSizeButton.getAttribute('data-instock') === "false" ? "Out of Stock" :
                              matchingSizeButton.getAttribute('data-preorder') === 'true' ? "Pre-order" : "In stock";
            this.querySelector('#productStatus').textContent = stockStatus;

            // Update other UI elements
            this.setAddBtnText(matchingSizeButton, this.querySelector('#addToCart'));
            this.setShippingAndReturns();
            this.shippingDateOnSizeChange();
            this.metrologyInfo.net_weight = this.weightInGms;
            this.setLegalMetrologyInfo();
            
            // Handle sale status
            const addBtn = this.querySelector('#addToCart');
            const originalPriceText = this.querySelector('#originalPrice');
            if (this.currentPrice < this.originalPrice) {
                addBtn.classList.add('sale');
                originalPriceText.closest('.offer').style.display = 'flex';
            } else {
                addBtn.classList.remove('sale');
                originalPriceText.closest('.offer').style.display = 'none';
            }
            this.animateOffers();
        }
    });
  }

  shippingDateOnSizeChange() {
    let sizePickerBlock = this.querySelector('div.open-sizepicker');
    let addBtn = this.querySelector('#addToCart');
    addBtn.classList.remove('disabled');
    (sizePickerBlock) ? sizePickerBlock.classList.remove('alert'):null;
    let item = null;
    if(sizePickerBlock && sizePickerBlock.children.length > 0 ){
      var selectedATag = sizePickerBlock.querySelector('a.selected');
      item = (selectedATag) ? selectedATag : sizePickerBlock.firstElementChild;
    }
    if (item.classList.contains('out-of-stock')) { //item is out of stock
      s_string = "&nbsp;";

      this.querySelector('#shippingInfo').innerHTML = s_string;
      addBtn.classList.add('disabled');
      (sizePickerBlock) ? sizePickerBlock.classList.add('alert'):null;
      this.querySelector('#shippingInfo').parentElement.querySelector('span.shipping-middot').style.display = "none";
    }
    else { //item is in stock
      this.querySelector('#shippingInfo').parentElement.querySelector('span.shipping-middot').style.display = "inline-block";
      var shippingDate = item.getAttribute('data-shipping');
      var preorder = item.getAttribute('data-preorder');
      var currentTime = new Date();
      var currentOffset = currentTime.getTimezoneOffset();
      var sellerOffset = (typeof(time_zone_offset) != 'undefined' && time_zone_offset != null) ? parseInt(time_zone_offset) : 330;
      var sellerTime = new Date(currentTime.getTime() + (sellerOffset + currentOffset) * 60000);
      var day = sellerTime.getDay();
      var s_string;
      if (preorder == "True" || preorder == "true" || preorder == true) { // Item is on pre-order
        if (shippingDate == undefined || shippingDate == '' || shippingDate == "null" || shippingDate == "None" || (new Date(shippingDate) < new Date())) { // and no dates mentioned
          s_string = "Ships in a week"
        }
        else { // and has a ship date
          shippingDate = shippingDate.replace(/-/g, "/");
          let shipping_date = new Date(shippingDate);
          var monthsArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          var s_date = shipping_date.getDate();
          var s_month = monthsArray[shipping_date.getMonth()];
          var ship_date = s_month + " " + s_date.toString();
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          if (shipping_date > today) {
            var tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            if (shipping_date.getTime() === tomorrow.getTime()) {
                s_string = "Ships tomorrow";
            } else {
                s_string = `Ships on ${ship_date}`;
            }
          } else {
            s_string = `Ships on ${ship_date}`;
          }
        }
        this.querySelector('#shippingInfo').innerHTML = s_string
        this.querySelector('#shippingInfo').classList.add('preorder');
      }
      else { // Item is not on pre-order
        // cut off time for India is 4PM (16) and for UK is 3PM (15)
        // shipping holiday for india - sunday (0) and for UK  - sunday(0) and saturday(6)
        var cutOffTime = (seller == 'gb') ? 15 : 16;
        var sellerHours = sellerTime.getHours();
        var holiday = ( (day == 0 || day == 6 && seller == 'gb') || (day == 0 && seller == 'in') ) ? true : false;
        // s_string = 'Ships in 4 days'; // Hardcoded date
        if (holiday){
          s_string = (day == 0) ? 'Ships tomorrow' : 'Ships on Monday';
        }            
        else {
          if (sellerHours >= 0 && sellerHours < 8) { // time between 12AM to 8AM
            s_string = "Ships today";
          }
          else if (sellerHours >= 8 && sellerHours < cutOffTime) { // time between 8AM to cutOffTime
            let shipHours = 20 - sellerHours;
            s_string = "Ships in " + shipHours.toString() + " " + "hours";
          }
          else if (sellerHours >= cutOffTime && sellerHours <= 24) { // time between cutOffTime to 12AM
            // Last day of week  - for india - saturday and for UK - friday  
            var last_day_of_week = ( (day == 5 && seller == 'gb') || (day == 6 && seller == 'in') ) ? true : false;
            if (last_day_of_week)
              s_string = "Ships on Monday";
            else
              s_string = "Ships tomorrow";
          }
        }
        this.querySelector('#shippingInfo').innerHTML = s_string;
        this.querySelector('#shippingInfo').classList.remove('preorder');
        let originalPriceText = this.querySelector('#originalPrice');
        if (addBtn){
          if (!this.setAnonPrice){
            addBtn.innerHTML = `
              <p>Add for ${this.currentPrice}</p>
              <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
          }
          else{
            addBtn.innerHTML = `
              <p>Add to Cart</p>
              <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
          }
        }
        if (originalPriceText){
          originalPriceText.textContent = `Original Price ${this.originalPrice}`;
        }
      }
    }
  }

  async setProductAttributes() {
    let p_details = this;
    let radioSizePickerBlock = this.querySelector('div.radio-size-wrapper');
    let selectSizePickerBlock = this.querySelector('div.select-size-wrapper');

    if(typeof(this.products) === 'undefined')
      return;
    this.renderOpenSizePicker()
  }
  renderOpenSizePicker(){
    let sizePickerBlock = this.querySelector('div.open-sizepicker');
    let addBtn = this.querySelector('#addToCart');
    sizePickerBlock.innerHTML = ""
    addBtn.classList.remove('disabled');
    sizePickerBlock.classList.remove('alert');
    let size = this.getSizeFromCookies();
    for (let i = 0; i < this.products.length; i++) {
      let product = this.products[i];
      let aTag = document.createElement("a");
      aTag.textContent = product.size;
      aTag.setAttribute('data-sku', product.sku);
      aTag.setAttribute('data-price', product.price);
      aTag.setAttribute('data-original-price', product.original_price);
      aTag.setAttribute('data-finalSale', product.final_sale);
      aTag.setAttribute('data-shipping', product.shipping_date);
      aTag.setAttribute('data-preorder', product.preorder);
      aTag.setAttribute('data-instock', !product.out_of_stock);
      aTag.setAttribute('href', "javascript:void(0);");
      aTag.setAttribute('aria-label', 'Chest 32 - 36')
      aTag.setAttribute('data-range-inches', product.range_in_inches);
      aTag.setAttribute('data-length-inches', product.length_in_inches);
      aTag.setAttribute('data-range-cm', product.range_in_cms);
      aTag.setAttribute('data-length-cm', product.length_in_cms);
      aTag.setAttribute('data-weight-gms', product.weight_in_gms);
      aTag.classList.add("size","button", "button-medium", "rounded")
      this.setMultipleOffers(product.for_sale);
      if (size != null &&  typeof(size) != 'undefined' && product.size == size){
        aTag.classList.add("selected");
        this.weightInGms = product.weight_in_gms;
        this.metrologyInfo.net_weight = this.weightInGms;
        this.setLegalMetrologyInfo();

        let stockStatus = (product.out_of_stock) ? "Out of Stock" : "In stock";
        if(product.preorder){
          stockStatus = "Pre-order";
        }
        this.querySelector('#productStatus').textContent = stockStatus;
        this.finalSale = aTag.getAttribute("data-finalSale");
      }
      if (i == 0 || (size != null &&  typeof(size) != 'undefined' && product.size == size) ) {
        let originalPriceText = this.querySelector('#originalPrice');
        this.currentPrice = product.price;
        this.originalPrice = product.original_price;
        this.currentSize = product.size;
        if (!this.setAnonPrice){
          addBtn.innerHTML = `
            <p>Add for ${product.price}</p>
            <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
        }
        else{
          addBtn.innerHTML = `
            <p>Add to Cart</p>
            <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
        }
        originalPriceText.textContent = `Original Price ${product.original_price}`;
        // Add a sale class to addBtn if product is on sale (originalPrice > currentPrice). 
        if (product.sale){
          addBtn.classList.add('sale');
          originalPriceText.closest('.offer').style.display = 'flex';
          this.animateOffers();
        }
        else{
          addBtn.classList.remove('sale');
          originalPriceText.closest('.offer').style.display = 'none';
          this.animateOffers();
        }
        let stockStatus = (product.out_of_stock) ? "Out of Stock" : "In stock";
        if(product.preorder){
          stockStatus = "Pre-order";
        }
        this.querySelector('#productStatus').textContent = stockStatus;
      }
      let sizeLabel = ""
      var setExcplicitAriaLabel = ""
      if (product.out_of_stock) {
        sizeLabel= 'Out of Stock';
        aTag.classList.add('out-of-stock');
        aTag.classList.add('alert');
        setExcplicitAriaLabel = "Out of Stock"
        
      }
      this.setSizeAriaLabels(aTag, this.metrologyInfo.unit, this.metrologyInfo.rangeLabel, this.metrologyInfo.lengthLabel, setExcplicitAriaLabel);
      this.setLegalMetrologyInfo()
      sizePickerBlock.appendChild(aTag);
      aTag.addEventListener('click', (event => {
        let selectedSize = event.currentTarget;
        for (let children of sizePickerBlock.children) {
            if(children.classList.contains('selected')){
              children.classList.remove('selected');
            }
        }
        // if(!selectedSize.classList.contains('out-of-stock')){
          
        // }
        selectedSize.classList.add('selected');
        this.currentSize = selectedSize.textContent;
        this.currentPrice = selectedSize.getAttribute('data-price');
        this.originalPrice = selectedSize.getAttribute('data-original-price');
        this.finalSale = selectedSize.getAttribute('data-finalSale');
        this.weightInGms = selectedSize.getAttribute('data-weight-gms');
        
        this.classList.remove('attention');

        let stockStatus = (selectedSize.getAttribute('data-instock') == "false") ? "Out of Stock": "In stock";
        if(selectedSize.getAttribute('data-preorder') == 'true'){
          stockStatus = "Pre-order";
        }
        this.querySelector('#productStatus').textContent = stockStatus;
        this.setAddBtnText(selectedSize, this.querySelector('#addToCart'))
        this.setShippingAndReturns();
        this.shippingDateOnSizeChange();
        this.metrologyInfo.net_weight = this.weightInGms;
        this.setLegalMetrologyInfo();
        this.setMultipleOffers(product.for_sale);
        
        // Add a sale class to addBtn if product is on sale (originalPrice > currentPrice).
        // Animate offers on size change 
        let addBtn = this.querySelector('#addToCart');
        let originalPriceText = this.querySelector('#originalPrice');
        if (product.sale){
          addBtn.classList.add('sale');
          originalPriceText.closest('.offer').style.display = 'flex';
          this.animateOffers();
        }
        else{
          addBtn.classList.remove('sale');
          originalPriceText.closest('.offer').style.display = 'none';
          this.animateOffers();
        }
      }));
    }
    let aTagSizeHelp = document.createElement('a');
    aTagSizeHelp.href = '#';
    aTagSizeHelp.className = 'size-help button button-medium rounded';
    aTagSizeHelp.id = 'sizeGuideBtn';
    aTagSizeHelp.setAttribute('aria-label', 'Size Guide');
    // Update the click handler in renderOpenSizePicker():
    if (this.getAttribute('type') == 'one-offs') {
      // attach global size guide as href
      aTagSizeHelp.href = '/size-guide';
    }
    else {
      
      aTagSizeHelp.addEventListener("click", function (event) {
        event.preventDefault();
        const sizeGuide = document.querySelector('size-guide');
        if (sizeGuide) {
            const sizeGuideDropdown = sizeGuide.querySelector('#sizeGuide');
            if (sizeGuideDropdown.classList.contains('visible')) {
                sizeGuideDropdown.classList.add('out-of-sight');
                sizeGuideDropdown.classList.remove('visible');
            } else {
                sizeGuideDropdown.classList.remove('out-of-sight');
                sizeGuideDropdown.classList.add('visible');
                
                // Close when clicking outside the size guide
                document.addEventListener('click', function closeHandler(e) {
                    if (!sizeGuideDropdown.contains(e.target) && e.target !== aTagSizeHelp) {
                        sizeGuideDropdown.classList.add('out-of-sight');
                        sizeGuideDropdown.classList.remove('visible');
                        document.removeEventListener('click', closeHandler);
                    }
                });
            }
        }
      });
    }
    sizePickerBlock.appendChild(aTagSizeHelp)
    if (sizePickerBlock.children.length > 0 ){
       this.finalSale = sizePickerBlock.firstElementChild.getAttribute('data-finalSale');
       const selectedSizeCount = sizePickerBlock.querySelectorAll('a.selected').length;
       if (selectedSizeCount > 0){
          var selectedATag = sizePickerBlock.querySelector('a.selected');
          this.currentSize = selectedATag.text;
       }
       else if (size == null || typeof(size) == 'undefined' || selectedSizeCount == 0){
        const firstAvailableSize = sizePickerBlock.querySelector('a:not(.out-of-stock):not(.size-help)');
        if (firstAvailableSize) {
            // THis is the case when the size is not set in the cookies
            firstAvailableSize.classList.add('selected');
            this.currentSize = firstAvailableSize.textContent;
        }
        else{
          // This is the case when there are no available sizes
          sizePickerBlock.firstElementChild.classList.add('selected');
          this.currentSize = sizePickerBlock.firstElementChild.textContent;
        }
       }

       const selectedSizeElement = sizePickerBlock.querySelector('a.selected');
       if (selectedSizeElement && selectedSizeElement.getAttribute('data-instock') == 'false'){
        const availableSize = sizePickerBlock.querySelector('a:not(.out-of-stock):not(.size-help)');
        if (availableSize) {
            // THis is the case when the size is not set in the cookies
            selectedSizeElement.classList.remove('selected');
            availableSize.classList.add('selected');
            this.currentSize = availableSize.textContent;
        }
       }
    }
    this.setAddBtnText(sizePickerBlock.querySelector('a.selected'), addBtn);
  }

  attachAddButtonClick() {
    var addBtn = this.querySelector('#addToCart');
    if (addBtn) {
      var details = this;
      addBtn.addEventListener('click', (event => {
        let originalPriceText = this.querySelector('#originalPrice');
        event.preventDefault();
        let sizePickerBlock = this.querySelector('div.open-sizepicker');
        let selectedSize = sizePickerBlock.querySelector('a.selected');;
        if (!selectedSize){
          return;
        }
        addBtn.innerHTML = '&#10003;';
        let sku = selectedSize.getAttribute('data-sku');
        let userCart = document.querySelector('user-cart');
        if (userCart) {
          userCart.cartAddingAnim();
          userCart.addToCart(1, sku);
          // Attach the Cart updated event to Reset the add button text
          userCart.addEventListener('cartUpdated', function (e) {
            setTimeout(() => {
              if (!details.setAnonPrice){
                addBtn.innerHTML = `
                  <p>Add for ${details.currentPrice}</p>
                  <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
              }
              else{
                addBtn.innerHTML = `
                  <p>Add to Cart</p>
                  <p class="super-subtle mrp-text">MRP (Inc. of all Taxes)</p>`;
              }
            }, 400)
          });
        }
      }));
    }
  }
  animateOffers(){
    let allOffersBlock = this.querySelector('.active-offers');
    let activeOffersCount = 0;
    for(let offer of allOffersBlock.children){
      if (offer.style.display != 'none'){
        activeOffersCount += 1;
      }
    }
    if ( activeOffersCount > 1 ){
      allOffersBlock.classList.add('multiple');
    }
    else {
      allOffersBlock.classList.remove('multiple');
    }
  }
}
window.customElements.define('product-details', ProductDetails);
